"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeValueOrFn = exports.CustoComponent = void 0;

var react_1 = __importDefault(require("react"));

var html_1 = require("../utils/html");

var flags_1 = require("../flags");

var objects_1 = require("../utils/objects");

var set_1 = require("../utils/set");

var react_sanitize_dom_props_1 = require("react-sanitize-dom-props");

var CustoComponent =
/** @class */
function () {
  /* eslint-enable */
  function CustoComponent(comp, defaultProps, additionalOptions) {
    this.$$end$$ = true;
    /* eslint-disable */

    this.outerBeforeComponents = [];
    this.outerAfterComponents = [];
    this.outerWrapperComponents = [];
    this.outermostWrapperComponents = [];
    this.innerStartComponents = [];
    this.innerEndComponents = [];
    this.innerWrapperComponents = [];

    this.transformProps = function (props) {
      return props;
    };

    this.component = comp;
    this.defaultProps = defaultProps || {};
    additionalOptions = additionalOptions || {};

    if (additionalOptions.outerBeforeComponents) {
      this.outerBeforeComponents = toArray(additionalOptions.outerBeforeComponents);
    }

    if (additionalOptions.outerAfterComponents) {
      this.outerAfterComponents = toArray(additionalOptions.outerAfterComponents);
    }

    if (additionalOptions.outerWrapperComponents) {
      this.outerWrapperComponents = toArray(additionalOptions.outerWrapperComponents);
    }

    if (additionalOptions.outermostWrapperComponents) {
      this.outermostWrapperComponents = toArray(additionalOptions.outermostWrapperComponents);
    }

    if (additionalOptions.innerStartComponents) {
      this.innerStartComponents = toArray(additionalOptions.innerStartComponents);
    }

    if (additionalOptions.innerEndComponents) {
      this.innerEndComponents = toArray(additionalOptions.innerEndComponents);
    }

    if (additionalOptions.innerWrapperComponents) {
      this.innerWrapperComponents = toArray(additionalOptions.innerWrapperComponents);
    }

    if (additionalOptions.transformProps) {
      this.transformProps = additionalOptions.transformProps;
    }

    this.name = additionalOptions.name;
    this.mergeStartegy = additionalOptions.mergeStartegy;
    this.propsMergeStrategy = additionalOptions.propsMergeStrategy;
    this.propsToDefaultPropsMergeStrategy = additionalOptions.propsToDefaultPropsMergeStrategy;
    this.avoidAnyMerging = !!additionalOptions.avoidAnyMerging;
    this.avoidLinkageMerging = !!additionalOptions.avoidLinkageMerging;
    this.avoidMergingDifferentComponents = !!additionalOptions.avoidMergingDifferentComponents;
    this.labels = additionalOptions.labels ? new Set(additionalOptions.labels) : new Set();
    this.stripPropKeys = additionalOptions.stripPropKeys;
    this.additionalMergeFlags = additionalOptions.additionalMergeFlags;
    this.subtractiveMergeFlags = additionalOptions.subtractiveMergeFlags;
    this.avoidStrippingInvalidDOMProps = !!additionalOptions.avoidStrippingInvalidDOMProps;
  }

  CustoComponent.prototype.render = function (props) {
    var _a = this.getMergedProps(props),
        initialChildren = _a.children,
        mergedProps = __rest(_a, ["children"]);

    var finalProps = this.transformProps(objects_1.removeKeys.apply(void 0, __spread([mergedProps], this.stripPropKeys || [])));

    if (typeof this.component === "string" && !this.avoidStrippingInvalidDOMProps) {
      finalProps = react_sanitize_dom_props_1.pickHTMLProps(finalProps, false);
    }

    var children = Array.isArray(initialChildren) ? initialChildren : initialChildren === undefined ? [] : [initialChildren];

    if (this.innerStartComponents.length || this.innerEndComponents.length) {
      children = this.innerStartComponents.map(renderMap).concat(children).concat(this.innerEndComponents.map(renderMap));
    }

    var inner = children;

    if (this.innerWrapperComponents.length > 0) {
      var innerComp = react_1.default.createElement.apply(react_1.default, __spread([react_1.default.Fragment, {}], inner));
      innerComp = wrapInComps.apply(void 0, __spread([innerComp], this.innerWrapperComponents));
      inner = [innerComp];
    }

    var mainElement = react_1.default.createElement.apply(react_1.default, __spread([this.component, finalProps], children));

    if (this.outerWrapperComponents.length > 0) {
      mainElement = wrapInComps.apply(void 0, __spread([mainElement], this.outerWrapperComponents));
    }

    if (this.outerBeforeComponents.length === 0 && this.outerAfterComponents.length === 0 && this.outermostWrapperComponents.length === 0) {
      return mainElement;
    }

    var children2 = react_1.default.createElement(react_1.default.Fragment, {}, this.outerBeforeComponents.map(renderMap), mainElement, this.outerAfterComponents.map(renderMap));

    if (this.outermostWrapperComponents.length === 0) {
      return children2;
    } else {
      return wrapInComps.apply(void 0, __spread([children2], this.outermostWrapperComponents));
    }
  };

  CustoComponent.prototype.mergeClass = function (cl, mergeFlags) {
    try {
      if (cl === this) return this;
      var mergeFlagsSet_1 = mergeFlags ? new Set(mergeFlags) : new Set();

      if (this.additionalMergeFlags) {
        set_1.unionWith.call(mergeFlagsSet_1, this.additionalMergeFlags);
      }

      if (this.subtractiveMergeFlags) {
        set_1.subtractSet.call(mergeFlagsSet_1, this.subtractiveMergeFlags);
      }

      if (!(cl instanceof CustoComponent)) return this;else if (this.mergeStartegy) {
        return this.mergeStartegy(this, cl, mergeFlagsSet_1);
      }
      var component = this.component === null || this.component === undefined ? cl.component : this.component;

      if (this.avoidAnyMerging || cl.avoidAnyMerging) {
        return this;
      }

      if (mergeFlagsSet_1.has(flags_1.CustoMergeFlagEnum.avoidWithPackageDefaultValue) && (this.labels.has(flags_1.CustomizableLabels.packageDefaultValue) || cl.labels.has(flags_1.CustomizableLabels.packageDefaultValue))) {
        return this;
      }

      if (mergeFlagsSet_1.has(flags_1.CustoMergeFlagEnum.avoidWithNonPackageValue) && (!this.labels.has(flags_1.CustomizableLabels.packageDefaultValue) || !cl.labels.has(flags_1.CustomizableLabels.packageDefaultValue))) {
        return this;
      }

      if (mergeFlagsSet_1.has(flags_1.CustoMergeFlagEnum.linking) && mergeFlagsSet_1.has(flags_1.CustoMergeFlagEnum.avoidLinking)) {
        return this;
      }

      if ((this.avoidMergingDifferentComponents || cl.avoidMergingDifferentComponents) && component !== cl.component) {
        return this;
      }

      if ((this.avoidLinkageMerging || cl.avoidLinkageMerging) && mergeFlagsSet_1.has(flags_1.CustoMergeFlagEnum.linking)) {
        return this;
      }

      if (this.propsMergeStrategy) {
        var propsMergeStrategy_1 = this.propsMergeStrategy;

        var normalizedPropsMergeStrategy = function normalizedPropsMergeStrategy(currentComponentProps, secondaryComponentProps) {
          return propsMergeStrategy_1(currentComponentProps, secondaryComponentProps, mergeFlagsSet_1);
        };

        var mergedProps = exports.mergeValueOrFn(this.defaultProps, cl.defaultProps, normalizedPropsMergeStrategy);
        return new CustoComponent(component, mergedProps, this.getCopiedAdditionalOptions());
      }

      if (typeof component === "string" && typeof cl.component === "string") {
        var mergedProps = exports.mergeValueOrFn(this.defaultProps, cl.defaultProps, html_1.deepMergeHTMLProps);
        return new CustoComponent(component, mergedProps, this.getCopiedAdditionalOptions());
      }

      if (component !== this.component) {
        return new CustoComponent(component, this.defaultProps, this.getCopiedAdditionalOptions());
      }

      return this;
    } catch (e) {
      return this;
    }
  };

  CustoComponent.prototype.getMergedProps = function (props) {
    var defaultProps = typeof this.defaultProps === "function" ? this.defaultProps(props) : this.defaultProps;

    if (this.propsToDefaultPropsMergeStrategy) {
      return this.propsToDefaultPropsMergeStrategy(props, defaultProps);
    }

    return __assign(__assign({}, defaultProps), props);
  };
  /** Returns new Customized Component and adds new component to it */


  CustoComponent.prototype.addComponent = function (place,
  /** single or array of customized components */
  component,
  /** circular index */
  index) {
    var _a;

    var cloned = this.clone();
    var array = cloned.getComponentsArr(place);
    index = typeof index === "number" ? index : -1;
    index = getCirculatedIndex(index, array.length + 1);

    (_a = array).splice.apply(_a, __spread([index, 0], toArray(component)));

    return cloned;
  };

  CustoComponent.prototype.getComponentsArr = function (place) {
    if (place === "innerEnd") {
      return this.innerEndComponents;
    }

    if (place === "innerStart") {
      return this.innerStartComponents;
    }

    if (place === "innerWrapper") {
      return this.innerWrapperComponents;
    }

    if (place === "outerAfter") {
      return this.outerAfterComponents;
    }

    if (place === "outerBefore") {
      return this.outerBeforeComponents;
    }

    if (place === "outerWrapper") {
      return this.outerWrapperComponents;
    }

    if (place === "outermostWrapper") {
      return this.outermostWrapperComponents;
    }

    throw new Error("incorrect place " + place);
  };

  CustoComponent.prototype.clone = function () {
    return new CustoComponent(this.component, this.defaultProps, this.getCopiedAdditionalOptions());
  };

  CustoComponent.prototype.getCopiedAdditionalOptions = function () {
    return {
      outerAfterComponents: __spread(this.outerAfterComponents),
      outerBeforeComponents: __spread(this.outerBeforeComponents),
      outerWrapperComponents: __spread(this.outerWrapperComponents),
      outermostWrapperComponents: __spread(this.outermostWrapperComponents),
      innerEndComponents: __spread(this.innerEndComponents),
      innerStartComponents: __spread(this.innerStartComponents),
      innerWrapperComponents: __spread(this.innerWrapperComponents),
      avoidMergingDifferentComponents: this.avoidMergingDifferentComponents,
      mergeStartegy: this.mergeStartegy,
      labels: new Set(this.labels),
      avoidAnyMerging: this.avoidAnyMerging,
      avoidLinkageMerging: this.avoidLinkageMerging,
      propsMergeStrategy: this.propsMergeStrategy,
      name: this.name,
      transformProps: this.transformProps,
      stripPropKeys: this.stripPropKeys,
      additionalMergeFlags: this.additionalMergeFlags,
      subtractiveMergeFlags: this.subtractiveMergeFlags,
      avoidStrippingInvalidDOMProps: this.avoidStrippingInvalidDOMProps
    };
  };

  CustoComponent.create = function (comp, defaultProps, additionalOptions) {
    return new CustoComponent(comp, defaultProps, additionalOptions);
  };

  return CustoComponent;
}();

exports.CustoComponent = CustoComponent;

var toArray = function toArray(el) {
  if (Array.isArray(el)) return el;
  return [el];
};

exports.mergeValueOrFn = function (v1, v2, mergeFn) {
  if (typeof v1 !== "function" && typeof v2 !== "function") {
    return mergeFn(v1, v2);
  }

  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var val1 = typeof v1 === "function" ? v1.apply(void 0, __spread(args)) : v1;
    var val2 = typeof v2 === "function" ? v2.apply(void 0, __spread(args)) : v2;
    return mergeFn(val1, val2);
  };
};

var getCirculatedIndex = function getCirculatedIndex(index, length) {
  if (index >= 0 && index < length) return index;
  if (length <= 0) return 0;

  if (index > 0) {
    return index % length;
  }

  index = (index % length + length) % length;
  return index;
};

var renderMap = function renderMap(e, i) {
  return e.render({
    key: i
  });
};

var wrapInComps = function wrapInComps(comp) {
  var wrappers = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    wrappers[_i - 1] = arguments[_i];
  }

  var result = comp;

  for (var i = wrappers.length - 1; i >= 0; i--) {
    var wrapper = wrappers[i];
    result = wrapper.render({
      children: result
    });
  }

  return result;
};